<template>
  <div
    v-if="visible"
    class="deposit-pending-banner"
    :class="{ 'deposit-pending-banner--stacked': stackedBelowRisk }"
  >
    <div class="deposit-pending-banner__inner">
      <div class="deposit-pending-banner__body">
        <div class="deposit-pending-banner__icon" aria-hidden="true">!</div>
        <p class="deposit-pending-banner__text">
          <span>{{ i18n('global.deposit_pending_banner.description_before') }}</span>
          <span class="deposit-pending-banner__emphasis">{{ i18n('global.deposit_pending_banner.status') }}</span>
          <span>{{ i18n('global.deposit_pending_banner.description_after') }}</span>
          <button class="deposit-pending-banner__cta" type="button" @click="onResolveClick">
            {{ i18n('global.deposit_pending_banner.cta') }}
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore } from '../../store';

const router = useRouter();
const store = useStore();
const { t: i18n } = useI18n();

defineProps<{
  stackedBelowRisk?: boolean;
}>();

const visible = computed(() => {
  return !!store.getters.accessToken
    && store.getters.hasPendingDepositDetails
    && !store.getters.pendingDepositLoading;
});

const onResolveClick = () => {
  router.push({ path: '/dashboard/deposit', query: { openDetails: '1' } });
};
</script>

<style lang="less" scoped>
.deposit-pending-banner {
  width: 100%;
  margin-top: 0;
  margin-bottom: 24px;
  padding: 0 16px;
  box-sizing: border-box;
  background: var(--Black-Brand-Black, #2a251a);

  &__inner {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8.5px 16px;
    border-radius: 8px;
  }

  &--stacked &__inner {
    border-radius: 0 0 8px 8px;
  }

  &__body {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    max-width: 1200px;
    min-width: 0;
  }

  &__icon {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    border-radius: 50%;
    border: 1.5px solid #ffcd35;
    color: #ffcd35;
    background: transparent;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
  }

  &__text {
    margin: 0;
    color: #ffffff99;
    font-family: var(--font-secondary);
    font-size: 12px;
    font-weight: 400;
    line-height: 19.5px;
    letter-spacing: 0.25px;
  }

  &__emphasis {
    color: #ffffff;
    font-weight: 700;
  }

  &__cta {
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: #ffcd35;
    font-family: inherit;
    font-size: inherit;
    font-weight: 700;
    line-height: inherit;
    letter-spacing: inherit;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s ease;

    &:hover,
    &:focus,
    &:active {
      opacity: 0.85;
    }
  }
}

@media screen and (max-width: 640px) {
  .deposit-pending-banner {
    margin-bottom: 16px;
    padding: 0 16px;

    &__inner {
      align-items: flex-start;
      padding: 8.5px 16px;
    }

    &__body {
      gap: 8px;
    }

    &__text {
      line-height: 19.5px;
    }
  }
}
</style>
